import styled from "@style/theme";
import { px } from "@style/scaling";
import { STANDARD_EASING } from "@style/easing";

interface Props {
  checked: boolean;
  backgroundColor?: string;
}

export const Checkbox = styled.div<Props>`
  cursor: pointer;
  width: ${px(24)};
  height: ${px(24)};
  border-radius: ${px(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) =>
    p.checked ? p.backgroundColor || p.theme.contentColor : "transparent"};
  border: 1px solid ${(p) => (!p.checked ? p.theme.borderColor : "transparent")};
  transition: all 400ms ${STANDARD_EASING};

  &::after {
    content: "";
    margin-top: ${px(-2)};
    transition: all 300ms ${STANDARD_EASING};
    width: ${px(4)};
    height: ${px(8)};
    border: solid ${(p) => p.theme.backgroundColor};
    border-width: 0 ${px(2, 2)} 0;
    opacity: ${(p) => (p.checked ? "1" : "0.2")};
    transform: ${(p) => (p.checked ? "rotate(45deg) scale(1)" : "rotate(0) scale(0)")};
  }
`;
